<template>
    <DropDownButton
        :classes-prop="`header-dropdown`"
        btn-classes-prop="c-header__link"
        :is-header-dropdown="true"
    >
        <template #title>
            <span>Parent</span>
        </template>
        <template #items>
            <ul>
                <li>
                    <a :href="parentsPageLink" target="_blank" rel="noopener">
                        Parent's page
                    </a>
                </li>
            </ul>
        </template>
    </DropDownButton>
</template>
<script>
import DropDownButton from '@/core/ui/_legacy/DropDownButton.vue';

export default {
    components: { DropDownButton },
    computed: {
        parentsPageLink() {
            return 'https://parents.99math.com/';
        },
    },
};
</script>
<style lang="scss">
@use '@/scss/components/_components.header-dropdown.scss';
</style>
